<script setup lang="ts">
import type { MathTaskAssignment } from "~/types/article"

const props = defineProps({
  assignment: {
    type: Object as PropType<MathTaskAssignment>,
    required: true,
  },
  showSuggestions: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  showAssignmentInSuggestion: {
    type: Boolean as PropType<boolean>,
    default: true,
  },
})

const { data: suggestedSolutionsData } = useMathTaskSolutions()
const hideAssignmentText =
  props.showSuggestions && !props.showAssignmentInSuggestion
</script>
<template>
  <div class="text-[18px] md:text-[24px] [&>*]:font-national2">
    <u-rich-text
      v-show="!hideAssignmentText"
      :html="assignment.text"
    />
    <div
      :class="`${
        showSuggestions
          ? 'mt-3 rounded bg-green-lightest p-4 md:px-8 md:py-6 lg:rounded-lg'
          : ''
      }`"
    >
      <USuggestedSolutionSection
        v-if="showSuggestions"
        :sections="suggestedSolutionsData?.suggestedSolutions.get(assignment.id)"
      />
    </div>
  </div>
</template>
